import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import { TeamData } from "./sign-in-team";

export const mapTeamsToComboBoxItemModel = (
  teams?: TeamData[]
): ComboBoxItemModel[] | undefined => {
  if (!teams) {
    return [];
  }
  return teams.map(team => ({
    value: team.id,
    caption: team.name
  }));
};
